import axios from "axios";

let BASE_API_URL = "";
let BILLING_URL = "";
let PORTAL_NAME = "";
let COMPANY_NAME = "";
let SSO_URL = "";
let SSO_LOGOUT_URL = "";
let PAYMENT_GATEWAY_URL = "";
let ssoEnabled = null;
let IDENTIFIER = "";
let SHOW_CONTENT = false;
let API_DOCUMENTATION_LINK = "";
let USER_MANUAL_LINK = "";
let SUPPORT_YOUTUBE_LINK = "";
let CHAT_WITH_SUPPORT_LINK = "";
let CHAT_VIA_WHATSAPP_NUMBER = "";
let SUPPORT_EMAIL = "";
let OPEN_TROUBLE_TICKET_LINK = "";
let ASSETS_BASE_PATH = "./client-assets/";
let ASSET_OVERRIDES = {};

class ConfigService {
    async getConfiguration() {
        await axios.get(process.env.BASE_URL + "config.json").then(response => {
            console.log("Reponse: ", response.data.BASE_API_URL);

            BASE_API_URL = response.data.BASE_API_URL;
            BILLING_URL = response.data.BILLING_URL;
            PORTAL_NAME = response.data.PORTAL_NAME;
            COMPANY_NAME = response.data.COMPANY_NAME;
            ssoEnabled = (response.data.SSO_Enabled == 'true');
            SSO_URL = response.data.SSO_URL;
            SSO_LOGOUT_URL = response.data.SSO_LOGOUT_URL;
            PAYMENT_GATEWAY_URL = response.data.PAYMENT_GATEWAY_URL;
            IDENTIFIER = response.data.IDENTIFIER;
            SHOW_CONTENT = response.data.SHOW_CONTENT;
            API_DOCUMENTATION_LINK = response.data.API_DOCUMENTATION_LINK;
            USER_MANUAL_LINK = response.data.USER_MANUAL_LINK;
            SUPPORT_YOUTUBE_LINK = response.data.SUPPORT_YOUTUBE_LINK;
            CHAT_WITH_SUPPORT_LINK = response.data.CHAT_WITH_SUPPORT_LINK;
            CHAT_VIA_WHATSAPP_NUMBER = response.data.CHAT_VIA_WHATSAPP_NUMBER;
            SUPPORT_EMAIL = response.data.SUPPORT_EMAIL;
            OPEN_TROUBLE_TICKET_LINK = response.data.OPEN_TROUBLE_TICKET_LINK;
            ASSETS_BASE_PATH = response.data.ASSETS_BASE_PATH || "./client-assets/";
            ASSET_OVERRIDES = response.data.ASSETS || {};
        });
    }

    async getAssetsBasePath() {
        if (ASSETS_BASE_PATH === null || ASSETS_BASE_PATH === "") {
            await this.getConfiguration();
        }
        return ASSETS_BASE_PATH;
    }

    async getAssetOverrides() {
        await this.getConfiguration();
        return ASSET_OVERRIDES;
    }

    async getBillingUrl() {
        if (BILLING_URL === null || BILLING_URL === '') {
            await this.getConfiguration();
        }
        return BILLING_URL;
    }

    async getBaseAPIUrl() {
        if (BASE_API_URL === null || BASE_API_URL === '') {
            await this.getConfiguration();
        }
        return BASE_API_URL;
    }

    async getPortalName() {
        if (PORTAL_NAME === null || PORTAL_NAME === '') {
            await this.getConfiguration();
        }
        return PORTAL_NAME;
    }

    async getCompanyName() {
        if (COMPANY_NAME === null || COMPANY_NAME === '') {
            await this.getConfiguration();
        }
        return COMPANY_NAME;
    }

    async isSSOEnabled() {
        if (ssoEnabled === null || ssoEnabled === '') {
            await this.getConfiguration();
        }
        return ssoEnabled;
    }
    async getSSOURL(){
        await this.getConfiguration();
        return SSO_URL;
    }
    async getSSOLogout() {
        if (SSO_LOGOUT_URL === null || SSO_LOGOUT_URL === '') {
            await this.getConfiguration();
        }
        return SSO_LOGOUT_URL;
    }
    async getPaymentGatewayURL(){
        if (PAYMENT_GATEWAY_URL === null || PAYMENT_GATEWAY_URL === '') {
            await this.getConfiguration();
        }
        return PAYMENT_GATEWAY_URL
    }
    async getIdentifier() {
        if (IDENTIFIER === null || IDENTIFIER === '') {
            await this.getConfiguration();
        }
        return IDENTIFIER;
    }

    async getShowContent() {
        if (SHOW_CONTENT === null || SHOW_CONTENT === '') {
            await this.getConfiguration();
        }
        return SHOW_CONTENT;
    }

    async getApiDocumentationLink() {
        if (API_DOCUMENTATION_LINK === null || API_DOCUMENTATION_LINK === '') {
            await this.getConfiguration();
        }
        return API_DOCUMENTATION_LINK;
    }

    async getUserManualLink() {
        if (USER_MANUAL_LINK === null || USER_MANUAL_LINK === '') {
            await this.getConfiguration();
        }
        return USER_MANUAL_LINK;
    }

    async getSupportYoutubeLink() {
        if (SUPPORT_YOUTUBE_LINK === null || SUPPORT_YOUTUBE_LINK === '') {
            await this.getConfiguration();
        }
        return SUPPORT_YOUTUBE_LINK;
    }

    async getChatWithSupportLink() {
        if (CHAT_WITH_SUPPORT_LINK === null || CHAT_WITH_SUPPORT_LINK === '') {
            await this.getConfiguration();
        }
        return CHAT_WITH_SUPPORT_LINK;
    }

    async getChatViaWhatsappNumber() {
        if (CHAT_VIA_WHATSAPP_NUMBER === null || CHAT_VIA_WHATSAPP_NUMBER === '') {
            await this.getConfiguration();
        }
        return CHAT_VIA_WHATSAPP_NUMBER;
    }

    async getSupportEmail() {
        if (SUPPORT_EMAIL === null || SUPPORT_EMAIL === '') {
            await this.getConfiguration();
        }
        return SUPPORT_EMAIL;
    }

    async getOpenTroubleTicketLink() {
        if (OPEN_TROUBLE_TICKET_LINK === null || OPEN_TROUBLE_TICKET_LINK === '') {
            await this.getConfiguration();
        }
        return OPEN_TROUBLE_TICKET_LINK;
    }
}

export default new ConfigService()
